import React, {useContext} from 'react'  
import OrderContext from '../../../../context/OrderContext' 

import { useTranslation } from 'react-i18next';

const SearchOrder = () => {  
    
    const [t, i18n] = useTranslation('common');

    let { searchParams, setSearchParams, search, setSearch, searchValue, setSearchValue  } = useContext(OrderContext)  
     
        function handleChange(e){  
            setSearchValue(e.target.value) 
        }

        function handleClick(){  
            setSearch(searchValue) 
            searchParams.set('search', searchValue)
            setSearchParams(searchParams.toString()) 
        }

        function handleClearSearch(){ 
            setSearchValue('') 
            setSearch('')
            searchParams.delete('search'); 
            setSearchParams(searchParams.toString())   
        } 
    return (
        <> 
            <div className='search-block'> 
                <input name="search" id="search"  className='form-control search' placeholder={t('app.Search')} value={searchValue} onChange={handleChange } /> 
                <button type="submit" className="btn btn-secondary" onClick={handleClick} ><i className='feather icon-search'></i> {t('app.Search')}</button>
                {search ? <i className='feather icon-x clear' onClick={handleClearSearch}></i> : ''} 
            </div> 
        </>
    )
}

export default SearchOrder